import React, { useState } from 'react';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import '../containers/changePassword/modal.css';
import { Modal, Spin } from 'antd';
import MyButton from './Button';
import { ExclamationCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import { LoadingOutlined } from '@ant-design/icons';
import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import { FormattedMessage } from 'react-intl';

const UserProfileconfirmModal = (props) => {
  const { isOpenConfirm, handleCloseConfirm, onFinish, isloading } = props;
  const isDesktop = useIsDesktop();

  const confirma = () => {
    onFinish();
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 16,
      }}
      spin
    />
  );

  return (
    <>
      {isDesktop && isDesktop ? (
        <Modal
          open={isOpenConfirm}
          onOk={onFinish}
          onCancel={handleCloseConfirm}
          className='custom-modal'
          centered={true}
          width={400}
          footer={[
            <div>
              <MyButton
                onClick={handleCloseConfirm}
                style={{
                  width: isDesktop ? '25%' : '25%',
                  marginLeft: '0px',
                  marginTop: '0px',
                  marginRight: '5px',
                }}
              >
                <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
              </MyButton>{' '}
              <MyButton
                isPrimary
                onClick={onFinish}
                style={{
                  width: isDesktop ? '25%' : '25%',
                  marginInlineStart: '0px',
                }}
              >
                <FormattedMessage id='btnOK' defaultMessage='Ok' />
              </MyButton>
            </div>,
          ]}
        >
          {isloading === false ? (
            <div style={{ height: '100px' }}>
              <Typography isBold size='16px' color={COLORS.Primary} className='text-center p-2'>
                <FormattedMessage id='labelConfirmEdit' defaultMessage='Confirm Edit' />
              </Typography>
              <Typography className='text-center p-3'>
                <FormattedMessage id='textConfirmEdit' defaultMessage='Are you sure you want to edit your profile?' />
              </Typography>
            </div>
          ) : (
            <div>
              <Spin indicator={antIcon} />
            </div>
          )}
        </Modal>
      ) : (
        <Modal
          open={isOpenConfirm}
          onOk={onFinish}
          onCancel={handleCloseConfirm}
          centered
          className='custom-modal'
          width={300}
          style={{
            marginTop: isDesktop ? '270px' : '270px',
          }}
          footer={[
            <div>
              <MyButton
                onClick={handleCloseConfirm}
                style={{
                  width: isDesktop ? '25%' : '25%',
                  marginLeft: '0px',
                  marginTop: '0px',
                  marginRight: '5px',
                }}
              >
                <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
              </MyButton>{' '}
              <MyButton
                isPrimary
                onClick={onFinish}
                style={{
                  width: isDesktop ? '25%' : '25%',
                  marginInlineStart: '0px',
                }}
              >
                <FormattedMessage id='btnOK' defaultMessage='Ok' />
              </MyButton>
            </div>,
          ]}
        >
          <div style={{ height: '100px' }}>
            <Typography isBold size='16px' color={COLORS.Primary} className='text-center p-2'>
              <FormattedMessage id='labelConfirmEdit' defaultMessage='Confirm Edit' />
            </Typography>
            <Typography className='text-center p-3'>
              <FormattedMessage id='textConfirmEdit' defaultMessage='Are you sure you want to edit your profile?' />
            </Typography>
          </div>
        </Modal>
      )}
    </>
  );
};

export default UserProfileconfirmModal;
